import axios from 'axios'


export default function Deleter(condition, callback) {

    axios.delete(condition.url)

    .then(res => {

        callback({
            data : res.data.info || null,
            message : res.data.message
        })
    })

    .catch(err => {

        callback({
            data : null,
            message : 'ERROR'
        })

    })

} 



// WEBPACK FOOTER //
// ./src/controller/Deleter.js